export enum MultiBrokerTypesEnum {
  NO_BROKER = 1,
  SIMULATOR = 2,
  BROKER = 3
}
